import { render, staticRenderFns } from "./TreeRoot.vue?vue&type=template&id=6288be7a&"
import script from "./TreeRoot.vue?vue&type=script&lang=js&"
export * from "./TreeRoot.vue?vue&type=script&lang=js&"
import style0 from "./TreeRoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports